import React, { useEffect } from "react";
import { View, Text, StyleSheet, Image, TouchableOpacity } from "react-native";

const DefaultPage = ({ navigation, nextPage }) => {
  useEffect(() => {
    // Navigate to the next page after 2 seconds
    const timer = setTimeout(() => {
      navigation.navigate(nextPage);
    }, 2000);

    // Cleanup the timer if the component unmounts
    return () => clearTimeout(timer);
  }, []);
  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={() => navigation.navigate(nextPage)}>
        <View style={styles.logoContainer}>
          <Image
            source={require("../../assets/logo.png")} // Replace with your logo file
            style={styles.logo}
          />
          <Text style={styles.title}>Huxedo</Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#000",
    justifyContent: "center",
    alignItems: "center",
  },
  logoContainer: {
    alignItems: "center",
  },
  logo: {
    width: 100,
    height: 100,
    marginBottom: 20,
  },
  title: {
    fontSize: 24,
    color: "#fff",
    fontWeight: "bold",
  },
});

export default DefaultPage;
